export default __webpack_public_path__ + "static/hammer_b.2acacddba7c9c60509b1d20d1c30b1b2.svg";